import { render } from "./View.vue?vue&type=template&id=1825f4b4&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"

import "./View.vue?vue&type=style&index=0&id=1825f4b4&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1825f4b4"]])

export default __exports__